<template>
  <div>
    <div v-if="announcementSortToggle">
      <el-button
        style="margin-bottom: 10px"
        icon="el-icon-close"
        @click="cancelAnnouncementSort()"
        v-if="announcementSortToggle"
        >取消调整</el-button
      >
      <el-button
        style="margin-bottom: 10px"
        type="success"
        icon="el-icon-check"
        @click="saveAnnouncementSort()"
        v-if="announcementSortToggle"
        >保存调整</el-button
      >
    </div>
    <div v-else>
      <el-button
        style="margin-bottom: 10px"
        type="primary"
        icon="el-icon-plus"
        @click="openEditAnnouncementDialog(true)"
        v-if="!announcementSortToggle"
        >添加公告</el-button
      >
      <el-button
        style="margin-bottom: 10px"
        type="primary"
        icon="el-icon-sort"
        @click="announcementSortToggle = true"
        v-if="!announcementSortToggle && announcementTableData.length > 1"
        >调整顺序</el-button
      >
    </div>

    <el-table
      :data="announcementTableData"
      border
      size="small"
      style="width: 791px"
    >
      <el-table-column label="标题" align="center" width="300">
        <template slot-scope="scope">
          <div>{{ getDisplayTitleOfAnnouncement(scope.row) }}</div>
        </template>
      </el-table-column>
      <el-table-column label="多语言" align="center" width="150">
        <template slot-scope="scope">
          <el-popover placement="right" trigger="hover" width="600">
            <div>
              <el-tabs type="card" v-model="scope.row.activeLanguageTabName">
                <el-tab-pane
                  v-for="item in scope.row.languageAnnouncements"
                  :key="item.language"
                  :name="item.language"
                >
                  <span slot="label"
                    ><i
                      v-if="item.title == ''"
                      class="el-icon-info"
                      style="margin-right: 5px"
                    ></i
                    >{{ `[${item.language}]` }}</span
                  >
                  <div>
                    <label style="display: block">{{
                      `[${item.language}] 标题：`
                    }}</label>
                    <el-input v-model="item.title" readonly></el-input>
                  </div>
                  <div style="margin-top: 5px">
                    <label style="display: block">{{
                      `[${item.language}] 正文：`
                    }}</label>
                    <el-input
                      type="textarea"
                      rows="15"
                      v-model="item.content"
                      readonly
                    ></el-input>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
            <el-button slot="reference" size="small" icon="el-icon-view"
              >查看</el-button
            >
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column label="生效时间" align="center" width="140">
        <template slot-scope="scope">
          <div
            style="color: green"
            v-if="isShowOfAnnouncement(scope.row.showAt)"
          >
            生效中
          </div>
          <div v-else>{{ ms2ymdhmss(scope.row.showAt) }}</div>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="200">
        <template slot-scope="scope">
          <div v-if="announcementSortToggle">
            <el-button
              size="small"
              icon="el-icon-bottom"
              @click="onClickDownBtn(scope.row.id)"
              v-if="!isLastRow(scope.row.id)"
              >下移</el-button
            >
            <el-button
              size="small"
              icon="el-icon-top"
              @click="onClickUpBtn(scope.row.id)"
              v-if="!isFirstRow(scope.row.id)"
              >上移</el-button
            >
          </div>
          <div v-else>
            <el-button
              type="danger"
              size="small"
              icon="el-icon-delete"
              @click="deleteAnnouncement(scope.row)"
              >删除</el-button
            >
            <el-button
              size="small"
              icon="el-icon-edit"
              @click="openEditAnnouncementDialog(false, scope.row)"
              >修改</el-button
            >
          </div>
        </template>
      </el-table-column>
    </el-table>

    <!-- “编辑公告”对话框 -->
    <EditAnnouncementDialog
      v-if="shouldEditAnnouncementDialogVisible"
      @close="onEditAnnouncementDialogClosed()"
      :value="valueForEditAnnouncementDialog"
    ></EditAnnouncementDialog>
  </div>
</template>

<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";

import EditAnnouncementDialog from "./EditAnnouncementDialog";

export default {
  data() {
    return {
      shouldEditAnnouncementDialogVisible: false, // “添加邮件模板”对话框是否应该显示出来
      valueForEditAnnouncementDialog: null, // 要传递给“添加邮件模板”对话框的数据
      announcementTableData: [], // 邮件模板列表里展示的数据
      languages: [], // 所有的语言
      announcementSortToggle: false,
    };
  },

  components: {
    EditAnnouncementDialog,
  },

  async created() {
    // 查询语言集合
    this.languages = await bizutil.loadAvailableLanguages();

    // 拉取公告集合
    await this.loadAnnouncementList();
  },

  methods: {
    getDisplayTitleOfAnnouncement(announcement) {
      let zhTitle = "";
      let enTitle = "";

      for (let la of announcement.languageAnnouncements) {
        if (
          la.language.toLowerCase() == "zh" ||
          la.language.toLowerCase() == "cn"
        ) {
          zhTitle = la.title;
        } else if (la.language.toLowerCase() == "en") {
          enTitle = la.title;
        }
      }

      if (zhTitle != "") {
        return zhTitle;
      } else {
        return enTitle;
      }
    },

    isFirstRow(id) {
      return (
        this.announcementTableData && this.announcementTableData[0].id == id
      );
    },

    isLastRow(id) {
      return (
        this.announcementTableData &&
        this.announcementTableData[this.announcementTableData.length - 1].id ==
          id
      );
    },

    /**
     * 查询公告集合
     */
    async loadAnnouncementList() {
      // 清空表格数据
      this.announcementTableData = [];

      // 向服务器查询公告集合
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/getAnnouncements`,
          {},
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message({
          message: resData.message,
          type: "error",
        });
        return;
      }

      let announcementListInResponse = resData.data.announcements || [];

      for (let announcementInResponse of announcementListInResponse) {
        let languageAnnouncements = [];

        for (let language of this.languages) {
          let title = "";
          let content = "";

          for (let languageAnnouncementInResponse of announcementInResponse.languageAnnouncements) {
            if (languageAnnouncementInResponse.language == language) {
              title = languageAnnouncementInResponse.title;
              content = languageAnnouncementInResponse.content;
              break;
            }
          }

          languageAnnouncements.push({
            language: language,
            title: title,
            content: content,
          });
        }

        this.announcementTableData.push({
          id: announcementInResponse.id,
          showAt: announcementInResponse.showAt,
          languageAnnouncements: languageAnnouncements,
          activeLanguageTabName: this.languages[0],
        });
      }

      // 先给各个公告添加一个order值，order值会影响排序
      for (let i = 0; i < this.announcementTableData.length; i++) {
        this.announcementTableData[i].order =
          this.announcementTableData.length - i;
      }

      // 排序
      this.sortTableData();
    },

    /**
     * 打开“编辑公告”对话框
     */
    async openEditAnnouncementDialog(isCreate, announcement) {
      this.shouldEditAnnouncementDialogVisible = true;
      this.valueForEditAnnouncementDialog = {
        isCreate: isCreate,
        announcement: announcement,
      };
    },

    /**
     * “编辑公告”对话框关闭了
     */
    async onEditAnnouncementDialogClosed() {
      this.shouldEditAnnouncementDialogVisible = false;

      // 重新拉取公告集合
      return this.loadAnnouncementList();
    },

    /**
     * 删除一个公告
     * @param {*} tableRow
     */
    async deleteAnnouncement(tableRow) {
      try {
        // 弹确认框
        await this.$confirm(
          `确认删除公告“${this.getDisplayTitleOfAnnouncement(tableRow)}”？`
        );

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/deleteAnnouncement`,
            {
              id: tableRow.id,
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "删除成功",
          type: "success",
        });

        for (let i = 0; i < this.announcementTableData.length; i++) {
          if (this.announcementTableData[i].id == tableRow.id) {
            this.announcementTableData.splice(i, 1);
            break;
          }
        }
      } catch (e) {}
    },

    /**
     * 取消调整公告顺序
     */
    async cancelAnnouncementSort() {
      this.loadAnnouncementList();
      this.announcementSortToggle = false;
    },

    /**
     * 保存对公告顺序的调整
     */
    async saveAnnouncementSort() {
      let orderEntries = [];
      for (let row of this.announcementTableData) {
        orderEntries.push({
          id: row.id,
          order: row.order,
        });
      }

      try {
        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/updateAnnouncementsOrders`,
            {
              orderEntries: orderEntries,
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "保存成功",
          type: "success",
        });

        this.loadAnnouncementList();
        this.announcementSortToggle = false;
      } catch (e) {}
    },

    /**
     * 对表格数据进行排序
     */
    sortTableData() {
      this.announcementTableData.sort((a, b) => {
        return b.order - a.order;
      });
    },

    /**
     * 点击了公告“下移”按钮
     */
    async onClickDownBtn(id) {
      for (let i = 0; i < this.announcementTableData.length; i++) {
        if (this.announcementTableData[i].id != id) {
          continue;
        }

        if (i < this.announcementTableData.length - 1) {
          // 和排在下面的公告交换order值
          let currentOrder = this.announcementTableData[i].order;
          this.announcementTableData[i].order =
            this.announcementTableData[i + 1].order;
          this.announcementTableData[i + 1].order = currentOrder;

          // 重新排序
          this.sortTableData();
        }

        break;
      }
    },

    /**
     * 点击了公告“上移”按钮
     */
    async onClickUpBtn(id) {
      for (let i = 0; i < this.announcementTableData.length; i++) {
        if (this.announcementTableData[i].id != id) {
          continue;
        }

        if (i > 0) {
          // 和排在上面的公告交换order值
          let currentOrder = this.announcementTableData[i].order;
          this.announcementTableData[i].order =
            this.announcementTableData[i - 1].order;
          this.announcementTableData[i - 1].order = currentOrder;

          // 重新排序
          this.sortTableData();
        }

        break;
      }
    },

    // 公告是否对外显示了
    isShowOfAnnouncement(t) {
      if (t) {
        return Number(t) < new Date().getTime();
      }
      return true;
    },

    ms2ymdhmss(ts) {
      return util.ms2datetime(ts);
    },
  },
};
</script>